var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container"},[_c('div',{staticClass:"content"},[[_vm._l((_vm.itemList),function(v){return _c('Item',{key:v.id,attrs:{"every":v,"curcer":v.id},on:{"itemClick":_vm.goDetail}})}),_c('Scroll',{attrs:{"scrollFlag":_vm.scrollFlag,"isEnd":_vm.isEnd}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }